import { useTranslation } from 'react-i18next';
import { InfoIcon } from '@saesa/ui-kit-front';
import { TerDisplay, TIPO_FECHA_VACIO } from 'utils/formatters/dateFormatter';
import useStyles from './OutageDashboardStyles';

/**
 * Horarios de inicio/fin del corte programado o futuro más disclaimer.
 * @param inicioDisplay fecha/hora de inicio formateada
 * @param finDisplay fecha/hora de fin formateada
 * @param testIdHorarios data-testid de la caja de horarios
 * @param testIdDisclaimer data-testid del disclaimer
 */
const OutageHorariosConDisclaimer = ({
  inicioDisplay,
  finDisplay,
  testIdHorarios,
  testIdDisclaimer,
}: {
  inicioDisplay: TerDisplay;
  finDisplay: TerDisplay;
  testIdHorarios: string;
  testIdDisclaimer: string;
}) => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.kmlTerStack}>
      <div className={styles.terBox} data-testid={testIdHorarios}>
        <div className={styles.terTextoWrap}>
          {inicioDisplay.kind !== TIPO_FECHA_VACIO && (
            <p className={`${styles.terHora} ${styles.horaInicioAzul}`}>{inicioDisplay.principal}</p>
          )}
          <p className={styles.terSub}>{t('desconexion:paginas.mapaCortes.modalTracking.dashboard.programado.horaInicioSub')}</p>
        </div>
        <div className={styles.terTextoWrap}>
          {finDisplay.kind !== TIPO_FECHA_VACIO && <p className={styles.terHora}>{finDisplay.principal}</p>}
          <p className={styles.terSub}>{t('desconexion:paginas.mapaCortes.modalTracking.dashboard.programado.horaFinSub')}</p>
        </div>
      </div>
      <div className={styles.kmlDisclaimer} data-testid={testIdDisclaimer}>
        <InfoIcon className={styles.kmlDisclaimerIcon} />
        <p className={styles.kmlDisclaimerText}>
          {t('desconexion:paginas.mapaCortes.modalTracking.dashboard.programado.disclaimerHorarios')}
        </p>
      </div>
    </div>
  );
};

export default OutageHorariosConDisclaimer;
